export default [
  {
    path: '/b2bhub/operacoes/budget-lider',
    name: 'budget-lider',
    component: () => import('@/views/app/budgetLider/budgetsLider.vue'),
    meta: {
      pageTitle: 'Budget do Líder de Vendas',
      action: 'read',
      resource: 'BudgetLider',
    },
  },
  {
    path: '/b2bhub/operacoes/budget-lider-dashboard',
    name: 'budget-lider-dashboard',
    component: () => import('@/views/app/budgetLider/dashboardBudgetLider.vue'),
    meta: {
      pageTitle: 'Dashboard do Budget do Líder',
      action: 'read',
      resource: 'BudgetLider',
    },
  },
  {
    path: '/b2bhub/operacoes/budget-lider/:id',
    name: 'budget-lider-detalhes',
    component: () => import('@/views/app/budgetLider/DetalhesBudgetLider.vue'),
    meta: {
      pageTitle: 'Detalhes do Budget do Líder',
      navActiveLink: 'budget-lider',
      action: 'read',
      resource: 'BudgetLider',
    },
  },
];
